import { render, staticRenderFns } from "./TeamFilter.vue?vue&type=template&id=64d8b98e&scoped=true&"
import script from "./TeamFilter.vue?vue&type=script&lang=js&"
export * from "./TeamFilter.vue?vue&type=script&lang=js&"
import style0 from "./TeamFilter.vue?vue&type=style&index=0&id=64d8b98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8b98e",
  null
  
)

export default component.exports